import { UnorderedList } from 'atoms'

export const CollapsibleContentIdentity = () => (
  <>
    <h3 className="first-h3">Vor dem Coaching</h3>
    <UnorderedList items={[
      'Wer bin ich?',
      'Warum bin ich, wie ich bin?',
    ]} type="question" />

    <h3>Nach dem Coaching</h3>
    <UnorderedList items={[
      'So ergibt mein Leben Sinn.',
      `Ich lebe mein Leben und meine Werte und nutze meine Potenziale. Mein Leben ist wundervoll.`,
      'Mögliche Krisengebiete durchquere ich und werde dadurch stärker.',
    ]} type="check" />
  </>
)

export const CollapsibleContentRelationships = () => (
  <>
    <h3 className="first-h3">Vor dem Coaching</h3>
    <UnorderedList items={[
      'Wie führe ich gute Beziehungen?',
      'Wie kann ich auch ohne Partner glücklich leben?',
      'Wie meistere ich Probleme in der Partnerschaft?',
      'Wie pflege ich gute Beziehungen zu anderen Menschen?',
    ]} type="question" />

    <h3>Nach dem Coaching</h3>
    <UnorderedList items={[
      'Ich pflege gute Beziehungen und Freundschaften.',
      `Ich fühle mich geborgen und glücklich, mit oder ohne Partner/in.`,
      'Meine Freundschaften pflege ich.',
      'Das Leben mit meinen Kindern genieße ich.',
    ]} type="check" />
  </>
)

export const CollapsibleContentHealthBalance = () => (
  <>
    <h3 className="first-h3">Vor dem Coaching</h3>
    <UnorderedList items={[
      'Wie halte ich die Balance?',
      'Wieso ist dass eigentlich immer so ein Stress?',
      'Wie schütze ich mich wirksam vor Stressmonstern?',
      'Burn Out, was nun?',
      'Wie kann ich dauerhaft die Balance halten?',
      'Wie und wo finde ich mein persönliches Glück?',
      'Bin ich, was ich habe?',
      'Oder habe ich, was ich bin?',
    ]} type="question" />

    <h3>Nach dem Coaching</h3>
    <UnorderedList items={[
      'Ich achte auf meine Gesundheit, lebe in meinem Tempo, nehme mir Auszeiten.',
      'Ich sehe und spüre das Glück, jeden Tag.',
    ]} type="check" />
  </>
)

export const CollapsibleContentSelfDetermination = () => (
  <>
    <h3 className="first-h3">Vor dem Coaching</h3>
    <UnorderedList items={[
      'Wo will ich hin?',
      'Wie wähle und erreiche ich meine Ziele?',
      'Wie trete ich selbstbewusst auf?',
      'Wie behalte ich alles im Blick?',
      'Wie kommuniziere ich klar und durchsetzungsstark?',
      'Wie erreiche ich finanzielle Unabhängigkeit?',
    ]} type="question" />

    <h3>Nach dem Coaching</h3>
    <UnorderedList items={[
      'Meine Pläne sind klar.',
      'Die nächsten Etappen habe ich abgesteckt und gehe sie Schritt für Schritt.',
      `Ich agiere selbstbewusst, bin gut organisiert und kommunikationsstark, verhandle selbstsicher, agiere konstruktiv und angstfrei im Konflikt.`,
    ]} type="check" />
  </>
)

export const CollapsibleContentProfessionalLife = () => (
  <>
    <h3 className="first-h3">Vor dem Coaching</h3>
    <UnorderedList items={[
      'Beruf oder Berufung?',
      'Welchen Beruf soll ich wählen?',
      'Ich bin nicht mehr zufrieden, aber was jetzt?',
      'Ich führe, aber wie geht das?',
      'Wie steige ich nach längerer Auszeit wieder ein?',
      'Soll ich mich selbständig machen?',
    ]} type="question" />

    <h3>Nach dem Coaching</h3>
    <UnorderedList items={[
      'Ich wähle den Beruf, der mich erfüllt.',
      'Wenn ich mich verlaufen habe, orientiere ich mich neu.',
      'Es ist soweit, ich gehe in Führung.',
      'Den Wiedereinstieg in das Berufsleben meistere ich.',
      'Der Traum von der Selbständigkeit wird wahr.',
    ]} type="check" />
  </>
)

export const CollapsibleContentCrisis = () => (
  <>
    <h3 className="first-h3">Vor dem Coaching</h3>
    <UnorderedList items={[
      'Wie komme ich schnell aus der akuten Krise?',
      (
        <>
          Wie meistere Ich neue private Situationen, wie z.B. <em className="text-smaller">{`Trennungen/Scheidungen, Kinder aus dem Haus, Wechseljahre, Eintritt in das Rentenalter, Pflege von Angehörigen, Tod und Trauer, Mobbing/Dikriminierung, Kündigung, Arbeitslosigkeit, finanzielle Schieflagen, Einsamkeit, Krankheit`}</em>
        </>
      )
    ]} type="question" />

    <h3>Nach dem Coaching</h3>
    <UnorderedList items={[
      'Krisen gehören zum Leben einfach dazu.',
      'Ich kann private und berufliche Umbrüche gut meistern.',
      'Mögliche Krisengebiete durchquere ich und werde dadurch stärker.',
    ]} type="check" />
  </>
)
